module.exports = __webpack_public_path__ + "static/img/arthroscopy-19.0a54520.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-19.jpg
// module id = mfCp
// module chunks = 51